import { Turbo } from "@hotwired/turbo-rails"

const ALLOWED_TAGS = new Set(["b", "strong", "i", "em"])

const i18n = {
  title: () => document.querySelector("meta[name='turbo-confirm-title']")?.content ?? "Confirm",
  confirm: () => document.querySelector("meta[name='turbo-confirm-confirm']")?.content ?? "Confirm",
  cancel: () => document.querySelector("meta[name='turbo-confirm-cancel']")?.content ?? "Cancel",
}

Turbo.setConfirmMethod((message, element, submitter) => {
  return new Promise((resolve) => {
    let resolved = false

    const modal = buildConfirmModal()
    modal.querySelector("[data-turbo-confirm-message]").innerHTML = sanitizeConfirmHtml(message)
    document.body.appendChild(modal)

    modal.querySelector("[data-turbo-confirm-submit]").addEventListener("click", () => {
      resolved = true
      resolve(true)
      modal.remove()
    })

    const observer = new MutationObserver(() => {
      if (!document.contains(modal)) {
        observer.disconnect()
        if (!resolved) resolve(false)
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
  })
})

function buildConfirmModal() {
  const wrapper = document.createElement("div")
  wrapper.innerHTML = `
    <div
      id="turbo-confirm"
      class="modal show"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="turbo-confirm-title"
      data-controller="modal"
      data-modal-static-backdrop-value="false"
      data-modal-keyboard-value="true"
      data-action="keydown->modal#keydown"
    >
      <div class="modal-backdrop fade show" data-modal-target="backdrop" data-action="click->modal#backdropClose"></div>
      <div class="modal-dialog modal-dialog-centered" data-modal-target="dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="min-w-0 flex-1">
              <h1 id="turbo-confirm-title" class="modal-title">${i18n.title()}</h1>
            </div>
            <button type="button" class="btn-close" aria-label="${i18n.cancel()}" data-action="click->modal#close"></button>
          </div>
          <div class="modal-body">
            <p data-turbo-confirm-message></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-action="click->modal#close">${i18n.cancel()}</button>
            <button type="button" class="btn btn-primary" data-turbo-confirm-submit autofocus>${i18n.confirm()}</button>
          </div>
        </div>
      </div>
    </div>
  `
  return wrapper.firstElementChild
}

function sanitizeConfirmHtml(html) {
  const template = document.createElement("template")
  template.innerHTML = html

  Array.from(template.content.querySelectorAll("*")).forEach((element) => {
    if (!ALLOWED_TAGS.has(element.tagName.toLowerCase())) {
      element.replaceWith(document.createTextNode(element.textContent || ""))
      return
    }

  })

  return template.innerHTML
}
